export default __webpack_public_path__ + "static/media/app-store-badge.d75707cc.svg";